import React from 'react';
import { useTranslation } from 'react-i18next';
import Loader from '../../UI/Loader';
import JobAssignmentsTable from './JobAssignmentsTable';
import JobAssignmentsFilters from './JobAssignmentsFilters';
import { TableWrapper, NoResultText } from './SharedStyledComponents';
import { useJobAssignments } from '../../hooks/useJobAssignments';

const JobAssignmentsOverview = () => {
    const [t] = useTranslation();

    const {
        loading,
        filterOptionsLoading,
        assignments,
        pagination,
        filterOptions,
        filters,
        handleFormChange,
        handleSort,
        handlePageChange,
    } = useJobAssignments();

    return (
        <>
            <JobAssignmentsFilters
                filterOptions={filterOptions}
                filterOptionsLoading={filterOptionsLoading}
                onFilter={handleFormChange}
                assignments={assignments}
                filters={filters}
            />

            <TableWrapper>
                <Loader spinning={loading}>
                    {!loading && assignments.length === 0 ? (
                        <NoResultText>{t('NO_ASSIGNMENTS_FOUND', 'No job assignments found')}</NoResultText>
                    ) : (
                        <JobAssignmentsTable
                            assignments={assignments}
                            pagination={pagination}
                            onSort={handleSort}
                            onPageChange={handlePageChange}
                            currentSort={filters.sort}
                        />
                    )}
                </Loader>
            </TableWrapper>
        </>
    );
};

export default JobAssignmentsOverview; 